<div class="flex flex-col gap-4">
    <p-confirmDialog></p-confirmDialog>

    <!-- Seção: Endereço -->
    <app-card-content [headerColor]="false" icon="pi pi-map-marker" title="Endereço">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div class="field md:col-span-2">
                <label class="font-semibold block mb-2">Endereço</label>
                <input pInputText class="w-full" [value]="enderecoConsultorio().endereco" [readonly]="true" />
            </div>
            <div class="field">
                <label class="font-semibold block mb-2">Bairro</label>
                <input pInputText class="w-full" [value]="enderecoConsultorio().bairro" [readonly]="true" />
            </div>
            <div class="field">
                <label class="font-semibold block mb-2">Município</label>
                <input pInputText class="w-full" [value]="enderecoConsultorio().municipio" [readonly]="true" />
            </div>
            <div class="field">
                <label class="font-semibold block mb-2">UF</label>
                <input pInputText class="w-full" [value]="enderecoConsultorio().uf" [readonly]="true" />
            </div>
            <div class="field">
                <label class="font-semibold block mb-2">CEP</label>
                <input pInputText class="w-full" [value]="enderecoConsultorio().cep" [readonly]="true" />
            </div>
        </div>

        @if (!loading() && erroEndereco()) {
            <div class="mt-2 text-red-500">{{ erroEndereco() }}</div>
        }
    </app-card-content>

    <!-- Seção: Telefone -->
    <app-card-content [headerColor]="false" icon="pi pi-phone" title="Telefone">
        @if (isEditing) {
            <div class="mb-5 rounded-lg border border-surface-200 bg-surface-50/40 p-4 md:p-5">
                <div class="mb-4 flex items-center gap-2">
                    <i class="pi pi-phone text-primary"></i>
                    <h5 class="m-0 font-semibold">Novo Telefone</h5>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
                    <div>
                        <label class="mb-2 block text-sm font-medium">Tipo</label>
                        <p-select [appendTo]="'body'" [options]="tipoTelefoneOptions" [(ngModel)]="novoTipoTelefone" optionLabel="label" optionValue="value" placeholder="Selecione" [style]="{ width: '100%' }"></p-select>
                    </div>
                    <div>
                        <label class="mb-2 block text-sm font-medium">DDD</label>
                        <input pInputText class="w-full" [(ngModel)]="novoDdd" maxlength="2" placeholder="11" />
                    </div>
                    <div class="lg:col-span-2">
                        <label class="mb-2 block text-sm font-medium">Telefone</label>
                        <input pInputText class="w-full" [(ngModel)]="novoTelefone" maxlength="10" placeholder="999999999" />
                    </div>
                    <div>
                        <label class="mb-2 block text-sm font-medium">Ramal</label>
                        <input pInputText class="w-full" [(ngModel)]="novoRamal" maxlength="10" placeholder="Opcional" />
                    </div>
                    <div class="md:col-span-2 lg:col-span-5">
                        <label class="mb-2 block text-sm font-medium">Observação</label>
                        <input pInputText class="w-full" [(ngModel)]="novaObservacao" maxlength="120" placeholder="Opcional" />
                    </div>
                </div>

                <div class="mt-4 border-t border-surface-200 pt-3 flex justify-end gap-2">
                    <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-text" (onClick)="cancelarCadastroTelefone()"></p-button>
                    <p-button label="Salvar" icon="pi pi-check" [disabled]="loading()" (onClick)="salvarTelefone()"></p-button>
                </div>
            </div>
        }

        @if (!loading() && erro()) {
            <div class="mt-2 text-red-500">{{ erro() }}</div>
        }

        <app-custom-table [data]="telefones()" [metadata]="tableMetadata" [loading]="loading()" [permissaoUf]="pessoa()?.uf ?? null"></app-custom-table>
    </app-card-content>
</div>
